module.exports = __webpack_public_path__ + "static/logo-be83bf6adae8901603be97d29886fcba.png";